import { render, staticRenderFns } from "./PersonnelRolesWidget.vue?vue&type=template&id=60c55f38"
import script from "./PersonnelRolesWidget.vue?vue&type=script&lang=js"
export * from "./PersonnelRolesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports